/**
 * Configuración específica para Ionic
 * Maneja rutas de assets y configuraciones globales
 */

/**
 * Tipo para la configuración de Ionic
 */
interface IonicConfigType {
  mode?: 'ios' | 'md';
  swipeBackEnabled?: boolean;
  rippleEffect?: boolean;
  animated?: boolean;
  setAssetPath?: (path: string) => string;
}

/**
 * Configuración de Ionic para la aplicación
 */
export const ionicConfig: IonicConfigType = {
  mode: 'ios', // Usar modo iOS por defecto para mejor consistencia
  swipeBackEnabled: false,
  rippleEffect: false,
  animated: true,
  
  // Configurar rutas de assets para evitar errores de URL
  setAssetPath: (path: string) => {
    // Usar la función global si está disponible
    if (typeof window !== 'undefined' && (window as any).__ionicAssetPath) {
      return (window as any).__ionicAssetPath(path);
    }

    // Fallback: configuración por defecto
    if (path.startsWith('http') || path.startsWith('//') || path.startsWith('./') || path.startsWith('../')) {
      return path;
    }

    if (path.startsWith('/')) {
      return `.${path}`;
    }

    if (path.includes('ionicons') || path.includes('svg')) {
      return path;
    }

    return `./assets/${path}`;
  }
};

/**
 * Inicializar configuración de assets para evitar errores de URL
 */
export const initializeAssetPaths = (): void => {
  // Configurar la URL base para los assets si no está definida
  if (typeof window !== 'undefined') {
    // Asegurar que document.baseURI esté disponible
    if (!document.baseURI) {
      const base = document.createElement('base');
      base.href = window.location.origin + window.location.pathname;
      document.head.insertBefore(base, document.head.firstChild);
    }
    
    // Configurar rutas de assets globalmente
    (window as any).__ionicAssetPath = (path: string) => {
      if (ionicConfig.setAssetPath) {
        return ionicConfig.setAssetPath(path);
      }
      return path;
    };
  }
};

/**
 * Configuración específica para iconos
 */
export const configureIonicIcons = (): void => {
  if (typeof window !== 'undefined') {
    // Configurar la ruta base para los iconos de Ionic
    const ioniconsPath = './assets/ionicons/';
    
    // Configurar variables globales para iconos
    (window as any).Ionicons = (window as any).Ionicons || {};
    (window as any).Ionicons.setAssetPath = (path: string) => {
      if (path.includes('ionicons')) {
        return path;
      }
      return ioniconsPath + path;
    };
  }
};
